import React from 'react'

export default function IconCollapse({ color = 'currentColor', ...rest }) {
    return (
        <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg' {...rest}>
            <path
                d='M15.0001 8.3335H11.6667M11.6667 8.3335V5.00016M11.6667 8.3335L16.6667 3.3335M5.00008 11.6668H8.33341M8.33341 11.6668V15.0002M8.33341 11.6668L3.33342 16.6668'
                stroke={color}
                strokeWidth='1.66667'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    )
}
